import React, { useState, useEffect } from 'react'
import { GameRow } from './weekStyles'
import { getShortDate } from '../../../../Utils/formatting/formatting'
import { TeamsCol } from './teamsCol'
import type { EventGQL } from '../../../../Api'
import { mapChampSeriesEvents } from '../../../../Utils'
import { Head2 } from '../../../../Components/Typography/Text.styles'

type WeekBoxParams = {
  events: EventGQL[]
}
type ChampEventObj = {
  [key: string]: EventGQL[]
}

export const ChampSeriesScoreSections: React.FC<
  React.PropsWithChildren<WeekBoxParams>
> = ({ events }) => {
  const [champEventObj, setChampEventObj] = useState<ChampEventObj>({
    roundRobin: [],
    semis: [],
    championship: [],
  })

  useEffect(() => {
    let mappedCSEvents = mapChampSeriesEvents(events)
    setChampEventObj(mappedCSEvents)
  }, [])

  return (
    <>
      <Head2 sideMargins={2}>Round Robin</Head2>
      {champEventObj.roundRobin.length > 0 &&
        champEventObj.roundRobin.map((event) => (
          <GameRow key={event.slugname}>
            <div className="gameCol">
              <p className="dateRow">{`${getShortDate(event.startTime)}`}</p>
              <TeamsCol event={event} />
            </div>
          </GameRow>
        ))}

      <Head2 sideMargins={2}>Semis</Head2>
      {champEventObj.semis.length > 0 &&
        champEventObj.semis.map((event) => (
          <GameRow key={event.slugname}>
            <div className="gameCol">
              <p className="dateRow">{`${getShortDate(event.startTime)}`}</p>
              <TeamsCol event={event} />
            </div>
          </GameRow>
        ))}

      <Head2 sideMargins={2}>Championship</Head2>
      {champEventObj.championship.length > 0 && (
        <GameRow key={champEventObj.championship[0].slugname}>
          <div className="gameCol">
            <p className="dateRow">{`${getShortDate(
              champEventObj.championship[0].startTime
            )}`}</p>
            <TeamsCol event={champEventObj.championship[0]} />
          </div>
        </GameRow>
      )}
    </>
  )
}
